import { render, staticRenderFns } from "./wel.vue?vue&type=template&id=5a4cf6f2&scoped=true"
import script from "./wel.vue?vue&type=script&lang=js"
export * from "./wel.vue?vue&type=script&lang=js"
import style0 from "./wel.vue?vue&type=style&index=0&id=5a4cf6f2&prod&scoped=scoped&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a4cf6f2",
  null
  
)

export default component.exports